import * as React from 'react';
import { Button, Modal, ModalVariant } from '@patternfly/react-core';
import { IIdleTimer } from 'react-idle-timer';

interface IdleLogoutModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const IdleLogoutModal: React.FC<IdleLogoutModalProps> = ({ isOpen, onClose }) => {
    return <Modal 
        title="You've been logged out"
        isOpen={isOpen}
        onClose={onClose}
        variant={ModalVariant.small}
        actions={[
            <Button key="userClose" variant="primary" onClick={onClose}>
                OK
            </Button>
        ]}
    >
        To keep your account safe, you were logged out due to inactivity.
    </Modal>
};

export default IdleLogoutModal;